/*  Card
 *
 * @file combined
 */

const rsCardLink = {
    init: (elems) => {
        const cards = Array.from(document.querySelectorAll(elems));
        cards.forEach(card => {
            card.addEventListener('click', function(e) {
                // Check if card has link or not.
                const isLink = this.children[0].classList.contains('rs_card__wrap-link');
                const target = this.children[0].getAttribute('target');
                // If there is a link, redirect page over there.
                if (isLink) {
                    const link = this.children[0].getAttribute('href');
                    if (target === '_blank') {
                        window.open(link);
                    } else {
                        window.location = link;
                    }
                }
            });
        });
    },
};

export default rsCardLink;
